import apiClient from "../common/apiClient";

export default class ServiceController {
    async Create(data, token) {
        try {
            return await apiClient.post("/service", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(departmentId, data, token) {
        try {
            return await apiClient.put("/service/" + departmentId, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/service/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllService(token) {
        try {
            return await apiClient.get("/getAllService", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
    async GetServiceBySubDepartmentId(id, token) {
        try {
            return await apiClient.get("/getServiceBySubDepartment/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
    async GetAllServiceByDepartment(id, token) {
        try {
            return await apiClient.get("/getServiceByDepartment/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
